"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }




 const normalizeMime = (mime) =>
  ((mime || '').split(';')[0] || '').trim().toLowerCase(); exports.normalizeMime = normalizeMime







const getFileExtension = (fileName) => {
  const basename = (fileName || '').split(/[\\/]/).pop() || ''
  const extension = basename.includes('.')
    ? _optionalChain([basename, 'access', _ => _.split, 'call', _2 => _2('.'), 'access', _3 => _3.pop, 'call', _4 => _4(), 'optionalAccess', _5 => _5.toLowerCase, 'call', _6 => _6()])
    : ''
  return extension || ''
}

const OFFICE_MIME_BY_EXTENSION = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
} 



const hasSupportedNonOfficeMime = (normalizedMime) =>
  normalizedMime === 'application/pdf' ||
  normalizedMime.startsWith('image/') ||
  normalizedMime.startsWith('video/') ||
  normalizedMime.startsWith('audio/')

const classifyOfficeMetadata = (
  mime,
  fileName,
) => {
  const normalizedMime = exports.normalizeMime.call(void 0, mime)
  const extension = getFileExtension(fileName)
  const mimeExtension = _optionalChain([(Object.entries(OFFICE_MIME_BY_EXTENSION) )
, 'access', _7 => _7.find, 'call', _8 => _8(([, officeMime]) => officeMime === normalizedMime), 'optionalAccess', _9 => _9[0]])
  const fileExtension = extension in OFFICE_MIME_BY_EXTENSION
    ? extension 
    : null

  if (mimeExtension) {
    if (!extension || fileExtension === mimeExtension) {
      return { extension: mimeExtension, conflict: false }
    }
    return { extension: null, conflict: true }
  }

  if (fileExtension && hasSupportedNonOfficeMime(normalizedMime)) {
    return { extension: null, conflict: false }
  }

  return { extension: fileExtension, conflict: false }
}

 const isPdf = (mime, fileName) =>
  exports.normalizeMime.call(void 0, mime) === 'application/pdf' || fileName.toLowerCase().endsWith('.pdf'); exports.isPdf = isPdf

 const isImage = (mime, fileName) =>
  exports.normalizeMime.call(void 0, mime).startsWith('image/') ||
  /\.(jpe?g|png|gif)$/i.test(fileName); exports.isImage = isImage

 const isVideo = (mime, fileName) =>
  exports.normalizeMime.call(void 0, mime).startsWith('video/') ||
  /\.(3g2|3gp|m4v|mov|mp4|webm)$/i.test(fileName); exports.isVideo = isVideo



 const formatMediaDuration = (ms) => {
  if (ms == null || !Number.isFinite(ms) || ms <= 0) return null

  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}; exports.formatMediaDuration = formatMediaDuration









 const hasValidImageDerivativeDimensions = (
  imageWidth,
  imageHeight,
) => Boolean(
  imageWidth && imageHeight &&
  Number.isFinite(imageWidth) && Number.isFinite(imageHeight) &&
  imageWidth > 0 && imageHeight > 0,
); exports.hasValidImageDerivativeDimensions = hasValidImageDerivativeDimensions

 const fitImageWithin = (
  width,
  height,
  maxWidth,
  maxHeight,
) => {
  const scale = Math.min(1, maxWidth / width, maxHeight / height)
  return {
    width: width * scale,
    height: height * scale,
  }
}; exports.fitImageWithin = fitImageWithin

 const shouldRenderImageDerivative = ({
  blurHash,
  imageWidth,
  imageHeight,
  thumbnailUrl,
  localPreviewUri,
}) => Boolean(
  blurHash || (
    thumbnailUrl && exports.hasValidImageDerivativeDimensions.call(void 0, imageWidth, imageHeight)
  ) || (
    localPreviewUri && exports.hasValidImageDerivativeDimensions.call(void 0, imageWidth, imageHeight)
  ),
); exports.shouldRenderImageDerivative = shouldRenderImageDerivative

 const getMimeFirstMediaKind = (
  mime,
  fileName,
) => {
  const normalizedMime = exports.normalizeMime.call(void 0, mime)
  if (normalizedMime.startsWith('image/')) return 'image'
  if (normalizedMime.startsWith('video/')) return 'video'

  const hasSpecificMime = /^[a-z0-9.+-]+\/[a-z0-9.+-]+$/.test(normalizedMime) &&
    normalizedMime !== 'application/octet-stream' &&
    normalizedMime !== 'binary/octet-stream'
  if (hasSpecificMime) return 'other'

  if (exports.isImage.call(void 0, '', fileName)) return 'image'
  if (exports.isVideo.call(void 0, '', fileName)) return 'video'
  return 'other'
}; exports.getMimeFirstMediaKind = getMimeFirstMediaKind

 const isAudio = (mime, fileName) =>
  exports.normalizeMime.call(void 0, mime).startsWith('audio/') ||
  /\.(aac|m4a|mp3|ogg|wav)$/i.test(fileName); exports.isAudio = isAudio

 const isOffice = (mime, fileName) =>
  classifyOfficeMetadata(mime, fileName).extension !== null; exports.isOffice = isOffice

 const isSupportedPreview = (mime, fileName, platform) =>
  exports.getSupportedPreviewDescriptor.call(void 0, mime, fileName, platform).supported; exports.isSupportedPreview = isSupportedPreview

 const getSupportedPreviewDescriptor = (
  mime,
  fileName,
  platform,
) => {
  const normalizedMime = exports.normalizeMime.call(void 0, mime)
  const extension = getFileExtension(fileName)
  const officeMetadata = classifyOfficeMetadata(mime, fileName)

  if (officeMetadata.conflict) {
    return { supported: false }
  }

  if (officeMetadata.extension) {
    if (platform !== 'ios') return { supported: false }
    return {
      supported: true,
      previewFamily: 'office',
      safeExtension: `.${officeMetadata.extension}`,
    }
  }

  if (normalizedMime === 'application/pdf' || extension === 'pdf') {
    return { supported: true, previewFamily: 'pdf', safeExtension: '.pdf' }
  }

  if (normalizedMime.startsWith('image/')) {
    if (normalizedMime === 'image/png') return { supported: true, previewFamily: 'image', safeExtension: '.png' }
    if (normalizedMime === 'image/gif') return { supported: true, previewFamily: 'image', safeExtension: '.gif' }
    return { supported: true, previewFamily: 'image', safeExtension: '.jpg' }
  }
  if (['jpg', 'jpeg'].includes(extension)) return { supported: true, previewFamily: 'image', safeExtension: '.jpg' }
  if (extension === 'png') return { supported: true, previewFamily: 'image', safeExtension: '.png' }
  if (extension === 'gif') return { supported: true, previewFamily: 'image', safeExtension: '.gif' }

  if (normalizedMime.startsWith('video/')) {
    if (normalizedMime === 'video/quicktime') return { supported: true, previewFamily: 'video', safeExtension: '.mov' }
    if (normalizedMime === 'video/webm') return { supported: true, previewFamily: 'video', safeExtension: '.webm' }
    if (normalizedMime === 'video/3gpp') return { supported: true, previewFamily: 'video', safeExtension: '.3gp' }
    if (normalizedMime === 'video/3gpp2') return { supported: true, previewFamily: 'video', safeExtension: '.3g2' }
    if (normalizedMime === 'video/x-m4v') return { supported: true, previewFamily: 'video', safeExtension: '.m4v' }
    return { supported: true, previewFamily: 'video', safeExtension: '.mp4' }
  }
  if (['3g2', '3gp', 'm4v', 'mov', 'mp4', 'webm'].includes(extension)) {
    return { supported: true, previewFamily: 'video', safeExtension: `.${extension}` }
  }

  if (normalizedMime.startsWith('audio/')) {
    if (normalizedMime === 'audio/aac') return { supported: true, previewFamily: 'audio', safeExtension: '.aac' }
    if (normalizedMime === 'audio/mp4' || normalizedMime === 'audio/x-m4a') return { supported: true, previewFamily: 'audio', safeExtension: '.m4a' }
    if (normalizedMime === 'audio/ogg') return { supported: true, previewFamily: 'audio', safeExtension: '.ogg' }
    if (normalizedMime === 'audio/wav' || normalizedMime === 'audio/x-wav') return { supported: true, previewFamily: 'audio', safeExtension: '.wav' }
    return { supported: true, previewFamily: 'audio', safeExtension: '.mp3' }
  }
  if (['aac', 'm4a', 'mp3', 'ogg', 'wav'].includes(extension)) {
    return { supported: true, previewFamily: 'audio', safeExtension: `.${extension}` }
  }

  return { supported: false }
}; exports.getSupportedPreviewDescriptor = getSupportedPreviewDescriptor

 const sanitizeMime = (mime) => {
  const normalized = exports.normalizeMime.call(void 0, mime)
  if (
    normalized.length > 80 ||
    !/^[a-z0-9.+-]+\/[a-z0-9.+-]+$/.test(normalized)
  ) {
    return 'unknown'
  }
  return normalized
}; exports.sanitizeMime = sanitizeMime

 const sanitizeExtension = (fileName) => {
  const extension = getFileExtension(fileName)
  if (
    !extension ||
    extension.length > 16 ||
    !/^[a-z0-9]+$/.test(extension)
  ) {
    return 'unknown'
  }
  return extension
}; exports.sanitizeExtension = sanitizeExtension

const getMimeCategory = (
  mime,
) => {
  const sanitizedMime = exports.sanitizeMime.call(void 0, mime)
  if (sanitizedMime === 'unknown') return 'unknown'

  const category = sanitizedMime.split('/')[0] || ''
  if (['application', 'image', 'video', 'audio', 'text'].includes(category)) {
    return category 
  }
  return 'other'
}

const SUPPORTED_TELEMETRY_EXTENSIONS = [
  'docx',
  'xlsx',
  'pptx',
  'doc',
  'xls',
  'ppt',
  'zip',
  'rtf',
  'pages',
  'webarchive',
  'csv',
  '7z',
] 

const getTelemetryExtension = (
  fileName,
) => {
  const extension = exports.sanitizeExtension.call(void 0, fileName)
  if (extension === 'unknown') return 'unknown'
  if ((SUPPORTED_TELEMETRY_EXTENSIONS ).includes(extension)) {
    return extension 
  }
  return 'other'
}

const getTelemetryPlatform = (
  platform,
) => {
  if (platform === 'ios' || platform === 'android') return platform
  if (!platform) return 'unknown'
  return 'other'
}

 const getSizeBucket = (
  size,
) => {
  if (typeof size !== 'number' || !Number.isFinite(size) || size < 0) return 'unknown'
  if (size < 100 * 1024) return '0-100kb'
  if (size < 1024 * 1024) return '100kb-1mb'
  if (size < 10 * 1024 * 1024) return '1-10mb'
  return '10mb+'
}; exports.getSizeBucket = getSizeBucket

 const buildUnsupportedAttachmentPreviewTelemetry = (
  metadata,
  platform,
) => ({
  attachment_preview_mime_category: getMimeCategory(metadata.mime),
  attachment_preview_extension: getTelemetryExtension(metadata.fileName),
  attachment_preview_size_bucket: exports.getSizeBucket.call(void 0, metadata.size),
  platform: getTelemetryPlatform(platform),
}); exports.buildUnsupportedAttachmentPreviewTelemetry = buildUnsupportedAttachmentPreviewTelemetry
